import $ from 'jquery';
import React,{useEffect} from 'react';
import {GetImgCertUser_CBack,appGetUrlPath,getWaUrlPath,TableDatePicker} from '../function_lib/common_lib';
import {Custom_Alert,Alert_Content} from '../components/custom_alert';
// import Comp_Stylus_Pen from './comp_stylus_pen';
import StylusCanvas from './comp_stylus';


import pdfIcon from '../assets/images/pdf_icon.png';
import mp3Icon from '../assets/images/mp3_icon.png';
import mp4Icon from '../assets/images/mp4_icon.png';

export function submitTaskStudet(){
  //alert($("#study_material_idnn").val());
    GetImgCertUser_CBack(this,"#frmTestYourKnow","submitCadetTask",function(checkData,checkMsg,userMsg){
      alert(checkData+"=="+checkMsg);    
      if(checkData===-10){
            
            Custom_Alert("Validation","Kindly fill required fields",false);
            return;
          }else {
            //alert("i m in else");
            Custom_Alert("Successfully Added","Successfully Added",true);
            //Custom_Alert("Successfully Added",checkMsg,false);
            //alert(checkMsg);
            //$('#divTestYourKnow').modal('hide');
            window.location.reload();
          }
        });
  }
export const Comp_Test_Your_Know=(props)=>{
  const getLatestDraw=(bImg)=>{
    //alert(bImg);
    $("#style_drwa").val(bImg);
  }
  let appUrl=appGetUrlPath();
  let appUrlFile=getWaUrlPath();
   useEffect(()=>{
    //alert(JSON.stringify(props.proItem));
   },[props.proItem])
        return(<div className="modal fade bd-example-modal-xl"  id="divTestYourKnow" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xxl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">{(typeof props.proItem!=="undefined" && typeof props.proItem.category_name!=="undefined")?"("+props.proItem.main_category+") "+props.proItem.category_name:''}</h5>
              <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
           
            <form id="frmTestYourKnow" name="frmTestYourKnow" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">
            <input type='hidden' name="curl_type" id="curl_type" value={"submitCadetTask"}/>
            <input type="hidden" name="m_type" id="m_type" value={"submitCadetTask"} />
            
            <input type="hidden" id="global_token" name="global_token" value={props.userObject[0]["id"]}/>
            <input type="hidden" id="local_token" name="local_token" value={props.userObject[0]["id"]}/>
            <input type="hidden" id="study_material_idnn" name="study_material_id" value={typeof props.proItem!=="undefined"?btoa(props.proItem.id):'0'} />

            <input type="hidden" name="lsBookTumb" id="lsBookTumb" />
            <input type="hidden" name="style_drwa" id="style_drwa"/>
                            <input type="hidden" name="lsImages" id="lsImages"/>
                            <input type="hidden" name="lsVideo" id="lsVideo"/>
                            <input type="hidden" name="lsPdf" id="lsPdf"/>

           
            <div className="modal-body">
            <div className="row">
                      {/* <!-- left column --> */}
                      <div className="col-md-12">
                          <div className="card card-danger">
                                   <div className="card-body">
                                    <h5>{"Test your knowledge"}</h5>
                                    <h6>{typeof props.proItem!=="undefined"?props.proItem["specifications"]:''}</h6>
                                    <textarea id="answers_txt" name="answers_txt" className='form-control' rows={"5"}>

                                    </textarea>
                                    <label>Use Stylus: <i class="fa fa-pencil-square-o fa-2x mr-5" aria-hidden="true"></i></label>
                                    <StylusCanvas latestDraw={getLatestDraw}/>
                                      <div className="col-md-6 respSSL"></div>
                                      <div id="testing2dd2222"></div>
                                  </div>
                              
                          </div>
                      </div>
                      </div>
                      <div id="idThumbOther" className="row imgLibThumb audioLibThumb imgOthLibThumb">
                      
                      </div>
                      <div class="row">
                      <input type="file" ref_img="ImageThumbBackNew" thumbnail_div={"oth_img_div"} lsElement={"lsImages"} thumbnail={"imgOthLibThumb"} multiple name="customOthFileBr" id="customOthFileBr" accept="image/*" capture="camera" size={1000000000} className="updImgThumb" />
                      <div className='col-md-4 center'>
                        {/* <a href={"javascript:void(0)"}>
                        <i className='fa fa-keyboard-o fa-2x mr-5'></i>
                        </a> */}
                        <a href={"javascript:void(0)"} setTo="customOthFileBr" className="_brFileThumb updthumb">
                        <i class="fa fa-camera fa-2x mr-2" aria-hidden="true"></i>
                        </a>
                        <a href={"javascript:void(0)"} setTo="customOthFileBr" className="_brFileThumb updthumb">
                        <i class="fa fa-paperclip fa-2x mr-2" aria-hidden="true"></i>
                        </a>
                        <a href={"javascript:void(0)"} setTo="customOthFileBr" className="_brFileThumb updthumb">
                        <i class="fa fa-keyboard-o fa-2x" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div className='col-md-1'>
                       
                      </div>
                      <div className='col-md-1'>
                     
                      </div>

                      
                  </div>
                  <div class="row">
                    <div class="col-12">
                    <div onClick={()=>submitTaskStudet()}  style={{marginRight:"10px"}} id="btnCatSearch" name="btnCatSearch" className="  bottom-fixed btn btn-sm btn-danger">Submit Task</div>
                    </div>
                  </div>
            </div>
            <div className="modal-footer mb-5">
            
                 {/* <div onClick={()=>this.resetFilters()} className="btn btn-sm btn-primary">STO Approve</div> */}
            <div id="getReponse" style={{color:"red"}}></div>
             
            </div>
            </form>
          </div>
          </div>
          </div>
      );
    
}
export default Comp_Test_Your_Know;
